import StoreBadges from "@/components/feature/StoreBadges";
import { track, withAttribution } from "@/lib/analytics";
import { BOOK_DEMO_URL, SIGNUP_URL } from "../data";

const TRUST_ITEMS = [
  "Trusted by 500+ businesses",
  "Live in 5 minutes",
  "No credit card",
  "Cancel anytime",
];

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex flex-col overflow-hidden bg-background-50">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-20 w-[560px] h-[560px] rounded-full joble-glow-accent"></div>
        <div className="absolute -bottom-32 -left-24 w-[520px] h-[520px] rounded-full joble-glow-primary"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center px-4 md:px-8 pt-28 pb-16">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-300/50 bg-background-100/60 px-4 py-1.5 mb-7">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulseSoft"></span>
            <span className="text-xs font-medium text-foreground-800 tracking-wide">
              AI Web Agent + Phone Agent for any business
            </span>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal text-foreground-950 tracking-tight leading-[1.08]">
            Never miss a<br className="hidden sm:block" /> customer <span className="italic font-semibold">again</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl mx-auto">
            Every call answered. Every visitor guided. Every opportunity captured. Joble turns
            conversations into bookings, orders, and revenue, automatically.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center gap-4 justify-center">
            <a
              href={withAttribution(SIGNUP_URL)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("try_joble_clicked", { location: "hero_primary" })}
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-base px-8 py-4 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Try Joble Now
              <span className="w-7 h-7 rounded-full bg-foreground-950/15 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
              </span>
            </a>
            <a
              href={withAttribution(BOOK_DEMO_URL)}
              onClick={() => track("book_demo_clicked", { location: "hero_secondary" })}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-background-300/60 text-foreground-900 font-semibold text-base px-8 py-4 hover:bg-background-100/70 transition-colors cursor-pointer whitespace-nowrap"
            >
              Book a Demo
            </a>
          </div>

          <div className="mt-8 flex flex-col items-center gap-3 md:hidden">
            <span className="text-xs font-medium text-foreground-600 tracking-wide">
              Get the Joble app
            </span>
            <StoreBadges justify="center" direction="col" />
          </div>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            {TRUST_ITEMS.map((item, index) => (
              <div key={item} className="flex items-center gap-4">
                {index > 0 && <span className="hidden sm:block w-1 h-1 rounded-full bg-foreground-500"></span>}
                <span className="text-xs md:text-sm font-medium text-foreground-700 tracking-wide whitespace-nowrap">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}